import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxLedger from '../util/remote/ajaxLedger';

const initialState = { 
    approvalList: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
    dateRange: { opening_date: "", closing_date: "" },
    fetchedPeriod: false,
    approvalStats: null,
    status: 'All',
    openingDate: '',
    closingDate: '',
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }
};



const ApprovalContext = createContext();

export const ApprovalProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(()=>{
    if(state.mounted){
      getTransactions(true);
    }
  }, [state.currentPage]);


 
  const getTransactions = async(refresh = false)=>{
    dispatch({ type: 'mounted', payload: true });
    if(!refresh && Array.isArray(state.approvalList)){
      return;
    }
    dispatch({ type: 'approvalList', payload: null });
    const server_response = await ajaxLedger.fetchLedgerApprovals({
      page: refresh ? 1 : state.currentPage,
      opening_date: state.openingDate,
      closing_date: state.closingDate,
      status: state.status,
    });
    if(server_response.status==="OK"){
      dispatch({ type: 'approvalList', payload: server_response.details.data });
      dispatch({ type: 'metaData', payload: server_response.details.meta });
    }else{
      dispatch({ type: 'approvalList', payload: "404" });
      dispatch({ type: 'metaData', payload: "404" });

    }
  }

  const getApprovalStats = async(refresh = false)=>{
    if(state.approvalStats && !refresh){
      return;
    }
    dispatch({ type: 'approvalStats', payload: null });
    const server_response = await ajaxLedger.fetchApprovalStats();
    if(server_response.status==="OK"){
      dispatch({ type: 'approvalStats', payload: server_response.details });
    }else{
      dispatch({ type: 'approvalStats', payload: null });
    }
  }

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const refresh = async() =>{
      await  getTransactions(true);
      await getApprovalStats(true);
  }

  return(
    <ApprovalContext.Provider value={{
      ...state, 
      dispatch, 
      getTransactions,
      getApprovalStats,
      setCurrentPage,
      refresh
      }}>
      {children}
    </ApprovalContext.Provider>
  )

}

export const useApproval = ()=>useContext(ApprovalContext);

